import StickySidebar from 'sticky-sidebar';
export function stickySidebar() {
  const sidebar = document.querySelector('.js-sticky-sidebar-container');
  if(sidebar !== null) {
    const stickySidebar = new StickySidebar('.js-sticky-sidebar-container', {
      topSpacing: 0,
      bottomSpacing: 0,
      containerSelector: '.js-sticky-sidebar-container',
      innerWrapperSelector: '.js-sticky-sidebar'
    });
    const updateMapSticky = () => {
      stickySidebar.updateSticky();
    }
    updateMapSticky();
    setInterval( () => {
      stickySidebar.updateSticky();
    }, 1000)
    window.addEventListener('resize', () => {
      stickySidebar.updateSticky();
    });
  }
}